import { APIProvider, Map, Marker, InfoWindow } from "@vis.gl/react-google-maps";
import { useState } from "react";

export const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const COLORS = { ON_TRIP: "#FF5A00", AVAILABLE: "#10B981", PARKED: "#10B981", MAINTENANCE: "#EF4444" };
const pinIcon = (status) => ({
  path: "M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z",
  fillColor: COLORS[status] || "#3B82F6", fillOpacity: 1, strokeColor: "#fff", strokeWeight: 2, scale: 1.5, anchor: { x: 12, y: 22 },
});

export function GoogleFleetMap({ data, onSelect }) {
  const [open, setOpen] = useState(null);
  return (
    <APIProvider apiKey={MAPS_KEY}>
      <div className="h-[560px] w-full overflow-hidden rounded-lg border border-white/10" data-testid="google-fleet-map">
        <Map defaultCenter={{ lat: data.hub.lat, lng: data.hub.lng }} defaultZoom={12} gestureHandling="greedy" mapTypeControl streetViewControl={false}>
          <Marker position={{ lat: data.hub.lat, lng: data.hub.lng }} title={data.hub.name} />
          {data.cars.filter((c) => c.lat != null && c.lng != null).map((c) => (
            <Marker key={c.id} position={{ lat: c.lat, lng: c.lng }} title={c.name} icon={pinIcon(c.status)}
              onClick={() => { setOpen(c); onSelect(c); }} />
          ))}
          {open && open.lat != null && (
            <InfoWindow position={{ lat: open.lat, lng: open.lng }} onCloseClick={() => setOpen(null)}>
              <div className="text-sm text-neutral-900"><b>{open.name}</b><br />{open.status?.replace("_", " ").toLowerCase()}</div>
            </InfoWindow>
          )}
        </Map>
      </div>
    </APIProvider>
  );
}

export function GoogleTripMap({ lat, lng, label }) {
  return (
    <APIProvider apiKey={MAPS_KEY}>
      <div className="h-72 w-full overflow-hidden rounded-2xl" data-testid="google-trip-map">
        <Map defaultCenter={{ lat, lng }} center={{ lat, lng }} defaultZoom={15} gestureHandling="cooperative" streetViewControl={false}>
          <Marker position={{ lat, lng }} title={label} />
        </Map>
      </div>
    </APIProvider>
  );
}
